import { apiSlice } from './apiSlice'

/** Mirrors FastAPI `SupplierExposureRow` (camelCase). One supplier row of the
 *  Risk Management ▸ Supplier's Exposure matrix (numbers are MT/USD, blank → null).
 *  The trailing grand-total row has `isTotal: true` — BE re-evaluates the
 *  conditional Room-to-buy measures over the whole dataset, so never re-sum
 *  client-side. */
export interface SupplierExposureRow {
  supplierName: string | null
  purchaseMt: number | null
  toReceiveMt: number | null
  toReceiveUsd: number | null
  outrightMt: number | null
  outrightUsd: number | null
  ptbfMt: number | null
  ptbfUsd: number | null
  rm1NpeBalanceUnpaid: number | null
  rm1Cumulative: number | null
  rm2PtbfBalance: number | null
  rm2Cumulative: number | null
  rm3CargoOffloaded: number | null
  rm3Cumulative: number | null
  rm4CargoInCompound: number | null
  rm4Cumulative: number | null
  exposureLimitMt: number | null
  exposureLimitUsd: number | null
  roomMt: number | null
  roomUsdWithRm2: number | null
  roomUsdWithoutMitigation: number | null
  isTotal: boolean
}

export interface SupplierExposureResponse {
  rows: SupplierExposureRow[]
  /** ISO date of the PBI header card (`min(max d_date, today)`). */
  reportDate: string | null
}

export const riskManagementApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getSupplierExposure: builder.query<SupplierExposureResponse, void>({
      query: () => '/dashboard/risk-management/supplier-exposure',
    }),
  }),
})

export const { useGetSupplierExposureQuery } = riskManagementApi
export default riskManagementApi
